import { jsx, jsxs } from "react/jsx-runtime";
import "react";
import { Flex, Text } from "pcln-design-system";
import { format } from "date-fns/format";
const MessageFooter = ({ date })=>{
    const footerMessageDateString = date ? format(date, "LLL d 'at' h:mm:ss aaa") : format(new Date(), "LLL d 'at' h:mm:ss aaa");
    return footerMessageDateString ? /*#__PURE__*/ jsx(Flex, {
        alignItems: "center",
        justifyContent: 'space-between',
        children: /*#__PURE__*/ jsxs(Text, {
            color: "text.light",
            textStyle: "subheading6",
            children: [
                "Penny \xb7 ",
                footerMessageDateString
            ]
        })
    }) : null;
};
const MessageFooter_MessageFooter = MessageFooter;
export { MessageFooter_MessageFooter as default };
